import { ReferralCodeCard, ReferralsStatistics, TotalEarningsCard } from '@/entities/referral'
import { RefPageHeader, RefTables } from '@/features/referrals'
import { StatisticTabNames } from '@/shared/lib/models/tabsStatisticOptions'
import { RootState } from '@/store/store'
import { useState } from 'react'
import { useSelector } from 'react-redux'

export const Referrals = () => {
  const [tabName, setTabName] = useState<StatisticTabNames>('payIn')
  const { trader } = useSelector((state: RootState) => state.trader)
  return (
    <div className="w-full flex flex-col gap-6">
      <RefPageHeader />
      <div className="flex gap-6  overflow-x-auto md:overflow-x-visible whitespace-nowrap md:whitespace-normal scrollbar-hide">
        <ReferralCodeCard referallCode={trader?.referralCode} />
        <TotalEarningsCard />
      </div>
      <ReferralsStatistics tabName={tabName} setTabName={setTabName} />
      <RefTables />
    </div>
  )
}
